var isDev = location.href.indexOf("localhost:") !== -1;
var isSITUAT = location.href.indexOf("-sit") !== -1 || location.href.indexOf("-uat") !== -1;

function getApUid() {
  const PREFIX = "sg282";
  const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let output = "";
  for (let i = 0; i < 8; i++) {
    output += CHARS.charAt(Math.floor(Math.random() * CHARS.length));
  }
  return PREFIX + output;
}

function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const variables = query.split("&");
  for (var i = 0; i < variables.length; i++) {
    var pair = variables[i].split("=");
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  console.log("Query variable %s not found", variable);
}

function callHotlineApi() {
  var token = sessionStorage.getItem("token") || getQueryVariable("token");
  $.ajax({
    type: "GET",
    url: `${isDev ? "/api" : ""}${token ? "" : "/web"}/rest/hotline`,
    headers: { apuid: getApUid() },
    beforeSend: function (request) {
      if (token) {
        request.setRequestHeader("token", token);
      }
    },
    error: function () {
      $("body").removeClass("ready");
    },
  }).done(function (data) {
    var hotlineList = data && data.result.list;
    hotlineList.map(function (item) {
      /** 联系方式名称 */
      var name = item.groupName || '';
      /** 图标 */
      var icon = item.icon;
      /** 代理加盟账号 */
      var agentAcc = item.agentAffAcc || '';
      /** 加盟账号 */
      var acc = item.acc || '';

      // for aff append agent account
      if ($(".aff-wrapper .contact-us").length !== 0) {
        var row = `<div class="contact-item">
                        <label>${name}</label>
                        <span>${agentAcc}</span>
                         <img src="img${icon}"/></div>`
        $(".contact-us .contact-table").append(row);
      }

      // for faq append agent account
      if ($(".faq-wrapper .contact-list").length !== 0) {
        var row = `<p><label>${name}: </label><span>${acc || ''}</span>${name.includes("金刚") ? " (加金刚时请注明您的用户名，否则将无法通过)" : ""}</p>`
        $(".faq-wrapper .contact-list").append(row);
      }
    });
  });
}

$(document).ready(function () {
  if ($(".contact-us").length !== 0) {
    callHotlineApi();
  }
});
